import { Divider, Grid, Theme } from '@mui/material';
import React from 'react';
import { useSelector } from 'react-redux';
import { selectExpandedModsDialog } from 'store/redux-store/placement-mods/selectors';
import { makeStyles } from 'tss-react/mui';
import { AllowanceCap } from './AllowanceCap';
import { AmountPerMile } from './AmountPerMile';
import { AssignTimeOff } from './AssignTimeOff';
import { Billable } from './Billable';
import { PayableTo } from './PayableTo';
import { Payer } from './Payer';

const useStyles = makeStyles<{ isExpanded: boolean }>()((theme: Theme, props) => ({
  gridContainer: {
    display: 'flex',
    flexDirection: 'row',
    flexWrap: 'wrap',
    alignContent: 'flex-start',
    minWidth: '550px',
    maxWidth: '550px',
    paddingBottom: '24px',
  },

  divider: {
    marginTop: '24px',
    paddingLeft: '24px',
  },
  root: {
    flexGrow: 1,
  },
}));

export const InterimTravel = () => {
  const isExpanded = useSelector(selectExpandedModsDialog);
  const { classes } = useStyles({ isExpanded: isExpanded });
  return (
    <>
      <div className={classes.root}>
        <Grid container spacing={4} className={classes.gridContainer}>
          <Grid xs={6} item>
            <Payer />
          </Grid>
          <Grid xs={6} item>
            <AmountPerMile />
          </Grid>

          <Grid xs={6} item>
            <PayableTo />
          </Grid>

          <Grid xs={6} item>
            <AllowanceCap />
          </Grid>
          <Grid xs={12} item>
            <Billable />
          </Grid>
          <Grid xs={12} className={classes.divider}>
            <Divider />
          </Grid>
        </Grid>
        <AssignTimeOff />
      </div>
    </>
  );
};
